var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.12939 6.73256C5.12939 6.15566 5.59706 5.68799 6.17397 5.68799H20.798C21.3749 5.68799 21.8425 6.15566 21.8425 6.73256C21.8425 7.30946 21.3749 7.77713 20.798 7.77713H6.17397C5.59706 7.77713 5.12939 7.30946 5.12939 6.73256Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21854 13C7.21854 12.4231 7.68621 11.9554 8.26311 11.9554H18.7088C19.2857 11.9554 19.7534 12.4231 19.7534 13C19.7534 13.5769 19.2857 14.0446 18.7088 14.0446H8.26311C7.68621 14.0446 7.21854 13.5769 7.21854 13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3522 18.2228C9.77535 18.2228 9.30768 18.6905 9.30768 19.2674C9.30768 19.8443 9.77535 20.312 10.3522 20.312H16.6197C17.1966 20.312 17.6642 19.8443 17.6642 19.2674C17.6642 18.6905 17.1966 18.2228 16.6197 18.2228H10.3522Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.ff114e70ed8bc62c497ff30035457d8f.svg";
export { ForwardRef as ReactComponent };